var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{class:[_vm.className , _vm.classes],style:(_vm.styles),domProps:{"innerHTML":_vm._s(_vm.$t(_vm.html))},on:{"input":_vm.updateComponent}})
}
var staticRenderFns = []

export { render, staticRenderFns }